export const touchActionNone = 0;
export const touchActionTrayA = 1;
export const touchActionTrayB = 2;
export const touchActionTrayC = 3;
export const touchActionDetailsPageA = 4;
export const touchActionDetailsPageB = 5;
export const touchActionDetailsPageC = 6;
export const touchActionWayfindingA = 7;
export const touchActionWayfindingB = 8;
export const touchActionWayfindingC = 9;
export const touchActionIframe = 11;
export const touchActionPDF = 12;
// DEV-12130: whole listing row opens the Wayfinding Modal (MAP button kept, same target)
export const touchActionDirectWayfinding = 14;

export const mobileClickButtons = 0;
export const mobileClickDirectCall = 1;
export const mobileClickDirectWayfinding = 2;
export const mobileClickDetails = 3;
export const mobileClickDirectPDF = 4;

export const mobileClickEventOptions = [
	{
		label: 'Buttons',
		value: mobileClickButtons,
	},
	{
		label: 'Direct Call',
		value: mobileClickDirectCall,
	},
	{
		label: 'Direct Wayfinding',
		value: mobileClickDirectWayfinding,
	},
	{
		label: 'Details',
		value: mobileClickDetails,
	},
	{
		label: 'Direct PDF',
		value: mobileClickDirectPDF,
	},
];